exports.dataArr = [
  {
    Sl_No: 1,
    public:false,
    Hospital_Names:
      "The Cure Urological Hospital (Private), \nSama-Savli Road, Vemali, Vadodara, Gujarat",
    Lat: 22.3522413,
    Lng: 73.20588385,
  },
  {
    Sl_No: 2,
    public:false,
    Hospital_Names:
      "Jhanvi Nursing Home (Private),\n2nd floor, Trupt complex, D Mart Rd, Vadodara, Gujarat 390025",
    Lat: 22.28939342,
    Lng: 73.22751411,
  },
  {
    Sl_No: 3,
    public:false,
    Hospital_Names:
      "Sterling Hospital Vadodara (Private),\nCircle West, Race Course Road Opposite Inox Cinema, Hari Nagar, Vadodara, Gujarat 390007",
    Lat: 22.3129789,
    Lng: 73.15888407,
  },
  {
    Sl_No: 4,
    public:false,
    Hospital_Names:
      "Tricolour Hospitals - Multispeciality Hospital in Vadodara (Private),\nDr. Vikram Sarabhai Road, Genda Cir, Vadiwadi, Vadodara, Gujarat 390007",
    Lat: 22.31733732,
    Lng: 73.16693259,
  },
  {
    Sl_No: 5,
    public:false,
    Hospital_Names:
      "Unity Multispeciality Hospital (Private),\nRajesh Tower Road, Opp. Suner Complex, Near, Hari Nagar Cross Rd, Gotri, Vadodara, Gujarat 390021",
    Lat: 22.3121299,
    Lng: 73.15248711,
  },
  {
    Sl_No: 6,
    public:false,
    Hospital_Names:
      "Gujarat Superspeciality Hospital Vadodara | Robotic Surgery  Center(Private) , Hospital in Vadodara | Urologist | Kidney Hospital,\nNew India Mill Compound Nr Jetalpur Bridge, Jetalpur Rd, Vadodara, Gujarat 390020",
    Lat: 22.30735414,
    Lng: 73.17576985,
  },
  {
    Sl_No: 7,
    public:false,
    Hospital_Names:
      "Aman Hospital & Research Center (Private),\n15 Shaswat, Gotri Rd, opposite ESI Hospital, Vadodara, Gujarat 390021",
    Lat: 22.30889448,
    Lng: 73.14879711,
  },
  {
    Sl_No: 8,
    public:false,
    Hospital_Names:
      "Samanvay Hospital (Private),\nVasna Rd, nr. St. Kabir School, opp. Raneshwar Temple, Krishnadham Society, Saiyed Vasna, Vadodara, Gujarat 390015",
    Lat: 22.2951567,
    Lng: 73.14961174,
  },
  {
    Sl_No: 9,
    public:false,
    Hospital_Names:
      "Aadicura Superspeciality Hospital Vadodara | Hospital in Vadodara (Private),\nJetalpur Rd, behind Gujarat Kidney Hospital, Anand Nagar, Haripura, Vadodara, Gujarat 390020",
    Lat: 22.30626466,
    Lng: 73.17576878,
  },
  {
    Sl_No: 10,
    public:false,
    Hospital_Names:
      "Nand Hospital (Private),\nNear Panchmukhi Hanuman Temple, Vasna - Bhayli Main Rd, next to Shantidham Society, Vadodara, Gujarat 390015",
    Lat: 22.29482948,
    Lng: 73.13800324,
  },
  {
    Sl_No: 11,
    public:false,
    Hospital_Names:
      "Bhailal Amin General Hospital (Private),\nBhailal Amin Marg, Road, Gorwa, Vadodara, Gujarat 390003",
    Lat: 22.3259374,
    Lng: 73.16328028,
  },
  {
    Sl_No: 12,
    public:false,
    Hospital_Names:
      "Galaxy multi-speciality hospital (Private),\n1, Shreeji darshan bunglows, Sun Pharma Rd, Vadodara, Gujarat 390012",
    Lat: 22.28021438,
    Lng: 73.14527647,
  },
  {
    Sl_No: 13,
    public:false,
    Hospital_Names:
      "VITAS Hospital (Private),\n Pragati Apartment, Dutt Vihar Society, Opp Income Tax Office Beside Kalyan Jewelers, Chakli Circle, Jetalpur Rd, Vadodara, Gujarat 390005",
    Lat: 22.30915224,
    Lng: 73.16613361,
  },
  {
    Sl_No: 14,
    public:false,
    Hospital_Names:
      "SARV Multi Speciality Hospital (Private),\nAxshar Pavillion, 74XH+JH3 Saiyed Vasna Road, Vasna - Bhayli Main Rd, nr. Priya Cinema, TP 4, Vadodara, Gujarat 390021",
    Lat: 22.29902832,
    Lng: 73.12873331,
  },
  {
    Sl_No: 15,
    public:false,
    Hospital_Names:
      "Venus Super Speciality Hospital (Private),\nOff OP Road Opp. Akota Ward Office No 6, Vadodara, Gujarat 390020",
    Lat: 22.28886364,
    Lng: 73.16529575,
  },
  {
    Sl_No: 16,
    public:false,
    Hospital_Names:
      "Sanjivani Hospital (Private),\nUjjwal Complex Besides Akota Stadium, Productivity Road, opposite Shrenik Park, Akota, Vadodara, Gujarat 390020",
    Lat: 22.29766942,
    Lng: 73.17188567,
  },
  {
    Sl_No: 17,
    public:false,
    Hospital_Names:
      "Zydus Hospitals (Private),\nOld Padra Rd, nr. Akshar Chowk, Hira Nagar, Tandalja, Vadodara, Gujarat 390020",
    Lat: 22.2814557,
    Lng: 73.16386254,
  },
  {
    Sl_No: 18,
    public:true,
    Hospital_Names:
      "Jamnabai General Hospital (Public),\n8626+2RC, Panigate Road, Mandvi Cir, Vadodara, Gujarat 390017",
    Lat: 22.30022807,
    Lng: 73.21208044,
  },
  {
    Sl_No: 19,
    public:false,
    Hospital_Names:
      "Savita Hospital (Private),\n76VR+6V8, Near Prakash Motor Garrage, Parivar Char Rasta, Dabhoi - Waghodia Ring Rd, Sarthi Nagar 2, Kendranagar, Vadodara, Gujarat 390019",
    Lat: 22.29598358,
    Lng: 73.24227652,
  },
  {
    Sl_No: 20,
    public:false,
    Hospital_Names:
      "Spandan Multispeciality Hospital (Private),\nMunicipal Corporation, Sindhwai Mata Road Beside Ward Office No: 4, Manjalpur, Vadodara, Gujarat 390011",
    Lat: 22.28152954,
    Lng: 73.20313773,
  },
  {
    Sl_No: 21,
    public:false,
    Hospital_Names:
      "Metro Hospital & Research Institute (Private),\nSama - Harni Rd, beside Kendriya Vidhyalaya, Shivam Park Society, BSNL Colony, Karelibagh, Vadodara, Gujarat 390022",
    Lat: 22.33965427,
    Lng: 73.20914588,
  },
  {
    Sl_No: 22,
    public:false,
    Hospital_Names:
      "Janvi Multispeciality Hospital (Private),\n302, Silver Square Complex, Airport Rd, near Gada Circle, Vadodara, Gujarat 390022",
    Lat: 22.34489383,
    Lng: 73.22013221,
  },
  {
    Sl_No: 23,
    public:false,
    Hospital_Names:
      "Premdas Jalaram Hospital (Private),\nRing Road, behind RTO Road, near Harmi, Premdas Nagar, Warasiya, Vadodara, Gujarat 390006",
    Lat: 22.31504156,
    Lng: 73.22356543,
  },
  {
    Sl_No: 24,
    public:false,
    Hospital_Names:
      "Anugrah Hospital (Private),\nTulshi Dham Rd, Krupal Society, Manjalpur, Vadodara, Gujarat 390009",
    Lat: 22.27326942,
    Lng: 73.20021949,
  },
  {
    Sl_No: 25,
    public:false,
    Hospital_Names:
      "Padma Hospital (Private),\nSamrundhi Residency Cum Plaza, 3rd Ln, Beside Makarpura Bus Depot, Bhakti Nagar, Makarpura, Vadodara, Gujarat 390010",
    Lat: 22.25261699,
    Lng: 73.19678626,
  },
  {
    Sl_No: 26,
    public:false,
    Hospital_Names:
      "Care Multispeciality Hospital (Private), Maneja,\nHotel sun city inn, Aarya's Corner Point Commercial Hub, Makarpura Rd, opp. Voltamp Company, Vadodara, Gujarat 390013",
    Lat: 22.2375229,
    Lng: 73.18803153,
  },
  {
    Sl_No: 27,
    public:false,
    Hospital_Names:
      "Kalavati Hospital (Private),\nHarni - Warasiya Ring Road, Vadodara, Gujarat 390006",
    Lat: 22.31200437,
    Lng: 73.22390876,
  },
  {
    Sl_No: 28,
    public:false,
    Hospital_Names:
      "Neeta Maternity & Gynec Hospital (Private),\nNo. C, 3, Harni - Warasiya Ring Rd, Dayal Nagar, Pramukhswami Nagar, Ganesh Nagar, Warasiya, Vadodara, Gujarat 390006",
    Lat: 22.31108129,
    Lng: 73.22441301,
  },
  {
    Sl_No: 29,
    public:false,
    Hospital_Names:
      "Secure ICU & Speciality Hospital (Private),\nGovindam complex, Opp., Dajidarshan, Old RTO Lane, Harni - Warasiya Ring Rd, Warasia, Vadodara, Gujarat 390022",
    Lat: 22.31264953,
    Lng: 73.22324357,
  },
  {
    Sl_No: 30,
    public:false,
    Hospital_Names:
      "Aayushya Multi Speciality Hospital (Private),Physician Surgeon Orthopedic Gynecologist Obstetrician PathLab ICU X Ray Trauma Care,\nopp. Darshnam Oasis, near My Shanen School, Mukhi Nagar, Ayodhya Nagar, 3, Vadodara, Gujarat 390019",
    Lat: 22.32171744,
    Lng: 73.23236196,
  },
  {
    Sl_No: 31,
    public:false,
    Hospital_Names:
      "Sumandeep Hospital (Private),\nKothi Rd, opp. Govt. Press, Anandpura, Vadodara, Gujarat 390001",
    Lat: 22.30415798,
    Lng: 73.19290667,
  },
  {
    Sl_No: 32,
    public:false,
    Hospital_Names:
      "Mahavir Multispeciality Hospital (Private),\nKala Darshan Society, Waghodia Road, Near Radhe Govind Apartment, Urmi Cross Rd, Vadodara, Gujarat 390025",
    Lat: 22.29343735,
    Lng: 73.22998552,
  },
  {
    Sl_No: 33,
    public:false,
    Hospital_Names:
      "Krishna Hospital (Private),\n1st Floor, Nilamber Complex, Narayan School Road, Ward No:3, Near Swaminarayan Gurukul Char Rasta, Kendranagar, Vadodara, Gujarat 390025",
    Lat: 22.28743203,
    Lng: 73.23719943,
  },
  {
    Sl_No: 34,
    public:false,
    Hospital_Names:
      "Sunshine Global Hospital (Private), Manjalpur,\nNR Shreyas Vidhyalay, near ICICI Bank Manjalpur, Vadodara-Branch & ATM, Manjalpur, Vadodara, Gujarat 390011",
    Lat: 22.27701105,
    Lng: 73.20010595,
  },
  {
    Sl_No: 35,
    public:false,
    Hospital_Names:
      "Kashtabhanjan Multispecialty Hospital (Private),\nPanchamrut Complex, 1, RV Desai Rd, Vrajpark, Lalbaug, Navapura, Vadodara, Gujarat 390001",
    Lat: 22.28633789,
    Lng: 73.20533706,
  },
  {
    Sl_No: 36,
    public:false,
    Hospital_Names:
      "DAYAMADHAV MULTISPECIALITY HOSPITAL (Private),\nRV Desai Rd, opp. MAIN GATE GANGOTRI APPARTMENTS, Khanderao Colony, Pratapnagar, Bakrawadi, Navapura, Vadodara, Gujarat 390001",
    Lat: 22.28969982,
    Lng: 73.20600748,
  },
  {
    Sl_No: 37,
    public:true,
    Hospital_Names:
      "Jamnabai General Hospital (Public),\n8626+2RC, Panigate Road, Mandvi Cir, Vadodara, Gujarat 390017",
    Lat: 22.30012294,
    Lng: 73.21202814,
  },
  {
    Sl_No: 38,
    public:false,
    Hospital_Names:
      "Vinayak Hospital (Private),\n1, Navneet Park Society, Near, Ayurvedic College Rd, Outside Panigate, Vadodara, Gujarat 390019",
    Lat: 22.29989463,
    Lng: 73.22176992,
  },
  {
    Sl_No: 39,
    public:false,
    Hospital_Names:
      "Faith Multi-speciality Hospitals Pvt.Ltd (Private),\nManav Mandir Society 1, 11/12 WATER TANK, Waghodia Rd, near PANIGATE, Vadodara, Gujarat 390019",
    Lat: 22.3009369,
    Lng: 73.22483837,
  },
  {
    Sl_No: 40,
    public:false,
    Hospital_Names:
      "BANKERS SUPERSPECIALITY HOSPITAL (Private),\nGIDC Road, Tulshi Dham Rd, opposite MAHALAXMI PARTY PLOT, Manjalpur, Vadodara, Gujarat 390011",
    Lat: 22.26448827,
    Lng: 73.1954797,
  },
];
